import { css } from "@emotion/core";

import { color, fontSizes } from "../../theme/Theme";

export const EligibilityGetstartedStyles = css({
  position: "absolute",
  top: "0",
  left: "0",
  height: "100vh",
  width: "100vw",
  background: color.overlay,
  ".greeting, .note": {
    color: color.white
  },
  ".note": {
    fontSize: fontSizes.h3Size
  }
});
